@if (isViewerActive() && bizEntityId() && readyEntityId() === bizEntityId()) {
  @if (category() === bizEntityTypeCategory.HayagrivaFilePDF) {
    <app-pdf-viewer [id]="bizEntityId()!" style="height: 100%;"></app-pdf-viewer>
  } @else if (category() === bizEntityTypeCategory.HayagrivaFileImage) {
    <app-image-viewer [id]="bizEntityId()!" style="height: 100%;"></app-image-viewer>
  } @else if (category() === bizEntityTypeCategory.HayagrivaFileVideo) {
    <app-video-viewer [id]="bizEntityId()!" style="height: 100%;"></app-video-viewer>
  } @else if (category() === bizEntityTypeCategory.HayagrivaFileMarkdown) {
    <app-markdown-editor [id]="bizEntityId()!" [rights]="mode()" [entity]="preparedEntity()" style="height: 100%;"></app-markdown-editor>
  } @else if (category() === bizEntityTypeCategory.HayagrivaFileWhiteboard) {
    <app-whiteboard-viewer [id]="bizEntityId()!" [onBack]="onBack()" [entity]="preparedEntity()" style="height: 100%;"></app-whiteboard-viewer>
  } @else if (
    category() === bizEntityTypeCategory.HayagrivaFileDoc ||
    category() === bizEntityTypeCategory.HayagrivaFileSpreadsheet ||
    category() === bizEntityTypeCategory.HayagrivaFileCSV ||
    category() === bizEntityTypeCategory.HayagrivaFilePresentation ||
    category() === bizEntityTypeCategory.HayagrivaFileDrawing ||
    category() === 30
  ) {
    <app-collabora-viewer [id]="bizEntityId()!" [rights]="mode()" style="height: 100%;"></app-collabora-viewer>
  }
}
